module.exports = __webpack_public_path__ + "img/curtain_up_90.d4c042f0.svg";